import { useNavigate } from "react-router-dom";
import { useState } from "react";
import API from "../utils/api";
import Swal from "sweetalert2";
const toast = (icon, title) => {
  Swal.fire({
    toast: true,
    position: "top-end", // 🔥 TOP RIGHT
    icon,
    title,
    showConfirmButton: false,
    timer: 2000,
    timerProgressBar: true
  });
};
export default function LoginPage() {
  const navigate = useNavigate();

  const [showPassword, setShowPassword] = useState(false);

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

const handleLogin = async () => {
  try {
    if (!username || !password) {
      return toast("warning", "Enter username & password");
    }

    const res = await API.post("/auth/login", {
      username,
      password
    });

    // Store the token along with user data
    localStorage.setItem("user", JSON.stringify(res.data));

    toast("success", "Login successful");
    navigate("/after-login", { replace: true });
  } catch (err) {
    toast("error", err.response?.data?.error || "Login failed");
  }
};

  return (
    <section className="login-page">
      <div className="login-box">
        <div className="row">

          {/* Logo */}
          <div className="login-logo mb-3 col-12 text-center">
            <img
              src="/img/royalking-logotext.png"
              alt=""
              className="img-fluid"
            />
          </div>

          {/* Username */}
          <div className="input-box mb-3 col-lg-12 col-6">
            <label>User Name</label>
            <input
              type="text"
              className="form-control input-login"
              placeholder="USER NAME"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
            />
          </div>

          {/* Password */}
          <div className="input-box mb-3 col-lg-12 col-6">
            <label>Password</label>
            <div className="password-input">
              <input
                type={showPassword ? "text" : "password"}
                className="form-control input-login"
                placeholder="ENTER PASSWORD"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              <img
                src={`/img/${showPassword ? "eye-open.png" : "eye-close.png"}`}
                alt=""
                className="eye-icon"
                onClick={() => setShowPassword(!showPassword)}
              />
            </div>
          </div>

          {/* Checkbox */}
          <div className="form-check mb-3 col-12">
            <input
              className="form-check-input"
              type="checkbox"
              id="checkDefault"
            />
            <label className="form-check-label" htmlFor="checkDefault">
              Default checkbox
            </label>
          </div>

          {/* Enter Button */}
          <div className="mb-3 col-lg-12 col-6">
            <button
              className="enter-18-btn"
              onClick={handleLogin}
            >
              18+ ENTER
            </button>
          </div>

          {/* Under 18 */}
          <div className="mb-3 col-lg-12 col-6">
            <button className="under-18">UNDER 18</button>
          </div>

        </div>
      </div>
    </section>
  );
}